import React from 'react';
import { Star, Quote } from 'lucide-react';

const ROW_1 = [
  { name: 'Ananya R.', city: 'Bengaluru', rating: 5, text: 'Booked a driver for 3 hours to run errands across the city — showed up on time and drove my car like his own. Super convenient.' },
  { name: 'Vikram S.', city: 'Delhi', rating: 5, text: 'Live tracking and the trip PIN made me feel safe handing my car keys to a stranger for the first time. Will book again.' },
  { name: 'Priya M.', city: 'Mumbai', rating: 4, text: 'Requested a female driver for a late evening trip and it worked flawlessly. Loved that there were no hidden charges.' },
  { name: 'Rahul K.', city: 'Pune', rating: 5, text: 'Cheaper than hiring a full-time driver and way less hassle than driving myself after a long business dinner.' },
  { name: 'Sneha T.', city: 'Hyderabad', rating: 5, text: 'The FASTag recharge inside the app saved me a separate trip. Small touch but genuinely useful on long drives.' },
];

const ROW_2 = [
  { name: 'Arjun D.', city: 'Chennai', rating: 5, text: 'Wedding season meant back-to-back events — booked drivers by the hour for a whole week without any surge pricing surprises.' },
  { name: 'Kavya N.', city: 'Kolkata', rating: 4, text: "Driver was verified, polite, and the app showed his rating upfront so I knew what to expect before he even arrived." },
  { name: 'Manish J.', city: 'Ahmedabad', rating: 5, text: 'Cancelled a booking by mistake and the refund landed instantly. Support chat sorted out my question in minutes.' },
  { name: 'Divya P.', city: 'Jaipur', rating: 5, text: "I don't enjoy city traffic — now I just book a driver, sit back, and let someone else deal with it." },
  { name: 'Sanjay B.', city: 'Noida', rating: 4, text: 'Simple hourly pricing meant I knew the exact cost before booking. No last-minute add-ons at all.' },
];

const TestimonialCard = ({ t, idx }) => (
  <div
    className="w-[320px] sm:w-[360px] flex-shrink-0 mx-3 bg-card rounded-2xl border border-border p-6 shadow-sm hover:shadow-lg transition-shadow"
    data-testid={`testimonial-card-${idx}`}
  >
    <div className="flex items-start justify-between mb-3">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold flex-shrink-0">
          {t.name[0]}
        </div>
        <div>
          <p className="font-semibold text-foreground text-sm leading-tight">{t.name}</p>
          <p className="text-xs text-muted-foreground">{t.city}</p>
        </div>
      </div>
      <Quote className="w-5 h-5 text-accent/50 flex-shrink-0" />
    </div>
    <div className="flex gap-0.5 mb-2" aria-label={`${t.rating} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`w-4 h-4 ${i < t.rating ? 'text-yellow-500 fill-yellow-500' : 'text-muted-foreground/30'}`} />
      ))}
    </div>
    <p className="text-sm text-foreground leading-relaxed">{t.text}</p>
  </div>
);

const MarqueeRow = ({ items, direction = 'left', offset = 0 }) => (
  <div className="flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
    <div
      className={`flex py-2 ${direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'} hover:[animation-play-state:paused]`}
    >
      {[...items, ...items].map((t, i) => (
        <TestimonialCard t={t} idx={offset + i} key={`${t.name}-${i}`} />
      ))}
    </div>
  </div>
);

export const TestimonialsMarquee = () => (
  <section className="bg-white py-20 overflow-hidden" data-testid="testimonials-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4">Loved by Riders Across India</h2>
        <p className="text-xl text-muted-foreground">Real stories from people who handed us the wheel</p>
      </div>
    </div>
    <div className="space-y-6">
      <MarqueeRow items={ROW_1} direction="left" offset={0} />
      <MarqueeRow items={ROW_2} direction="right" offset={100} />
    </div>
  </section>
);

export default TestimonialsMarquee;
